import { SkeletonLoader } from "@pepperstone/pepper-ui-kit";

type MobileFiltersSkeletonLoaderProps = {
  filtersToLoad: number;
};

export const MobileFiltersSkeletonLoader = ({
  filtersToLoad,
}: MobileFiltersSkeletonLoaderProps) => {
  return (
    <div
      className="mt-4 flex flex-col gap-4"
      data-testid="filter-mobile-skeleton-loader"
    >
      {Array.from({ length: filtersToLoad }, (_, i) => (
        <div key={i}>
          <SkeletonLoader variant="rectangular" height={10} />
        </div>
      ))}
    </div>
  );
};
